import React from 'react';
import { NavCard } from '@components/simba-cards';
import { NavCardLink } from '@components/styled-link/StyledLink';
import { useDocumentUrlWithNode } from '@hooks/Documents/useDocumentUrl';
import { InternalLinkType } from '@appTypes/internalLinkType';

interface Props {
  internalLink: InternalLinkType;
}

export const InternalLinkCard = ({ internalLink }: Props) => {
  const cardUrl = useDocumentUrlWithNode(internalLink);
  return (
    <NavCardLink to={cardUrl || 'undefined'}>
      <NavCard title={internalLink?.name} isInternalLink height="100%" />
    </NavCardLink>
  );
};
